import axios from "axios";

const keyService = {
    async getByGame(idGame) {
        return await axios.get(`/key/game/${idGame}`);
    }
}

export default keyService;